// extracted by mini-css-extract-plugin
export default {"Main":"StickyAlert_Main__nySg9","Link":"StickyAlert_Link__llb1E","CloseButton":"StickyAlert_CloseButton__ylI-s"};